import { isEmpty } from 'lodash';
import { browserHistory } from 'react-router';
import { supportSelector } from '../reducers/SupportReducer';
import SupportActionType from '../../common/SupportActionType';
import SupportService from '../../services/SupportService';

const fetchCategories = () => async (dispatch) => {
  dispatch({ type: SupportActionType.FETCH_CATEGORIES });
  SupportService.getCategories().then(
    categories => dispatch({ type: SupportActionType.STORE_CATEGORIES, categories })
  );
};

const fetchArticles = id => async (dispatch, getState) => {
  const categories = supportSelector.getCategories(getState());

  if (isEmpty(categories)) {
    await dispatch(fetchCategories());
  }

  const category = supportSelector.getCategory(id, getState());

  if (isEmpty(category)) {
    browserHistory.push('/support-centre');
    return;
  }

  dispatch({ type: SupportActionType.FETCH_ARTICLES, id });
  dispatch({ type: SupportActionType.STORE_ARTICLES,
    articles: await SupportService.getArticlesByCategory(category.queryParam),
    id
  });
};

const SupportAction = {
  fetchArticles,
  fetchCategories
};

export default SupportAction;



/** WEBPACK FOOTER **
 ** ./src/redux/actions/SupportAction.js
 **/